'use strict';

(function () {
    'use strict';

    // Usage:
    // 
    // Creates:
    // 

    ParkingStatusTableController.$inject = ['$interval', '$q', '$state', 'appConfig', 'iotService', 'localStorageService'];
    angular.module('app.admin').component('parkingStatusTable', {
        template: '<table class="table table-condensed table-striped table-hover" translate-namespace="admin.parking"><colgroup><col><col><col><col></colgroup><thead><tr><th><a ng-click="$ctrl.toggleOrderBy(\'name\')" translate>.Name</a> <span ng-show="$ctrl.orderBy.substring(1) === \'name\'"><i class="fa fa-sort-asc" ng-show="$ctrl.orderBy.substring(0,1) === \'+\'" aria-hidden="true"></i> <i class="fa fa-sort-desc" ng-show="$ctrl.orderBy.substring(0,1) === \'-\'" aria-hidden="true"></i></span></th><th><a ng-click="$ctrl.toggleOrderBy(\'presence\')" translate>.Status</a> <span ng-show="$ctrl.orderBy.substring(1) === \'presence\'"><i class="fa fa-sort-asc" ng-show="$ctrl.orderBy.substring(0,1) === \'+\'" aria-hidden="true"></i> <i class="fa fa-sort-desc" ng-show="$ctrl.orderBy.substring(0,1) === \'-\'" aria-hidden="true"></i></span></th><th class="text-right"><a ng-click="$ctrl.toggleOrderBy(\'since\')" translate>.Last change</a> <span ng-show="$ctrl.orderBy.substring(1) === \'since\'"><i class="fa fa-sort-asc" ng-show="$ctrl.orderBy.substring(0,1) === \'+\'" aria-hidden="true"></i> <i class="fa fa-sort-desc" ng-show="$ctrl.orderBy.substring(0,1) === \'-\'" aria-hidden="true"></i></span></th><th class="text-right"><a ng-click="$ctrl.toggleOrderBy(\'created_at\')" translate>.Last update</a> <span ng-show="$ctrl.orderBy.substring(1) === \'created_at\'"><i class="fa fa-sort-asc" ng-show="$ctrl.orderBy.substring(0,1) === \'+\'" aria-hidden="true"></i> <i class="fa fa-sort-desc" ng-show="$ctrl.orderBy.substring(0,1) === \'-\'" aria-hidden="true"></i></span></th></tr></thead><tbody ng-init="description_attr = (\'admin.parking.description\' | translate)"><tr ng-repeat="device in $ctrl.devices | orderBy: [$ctrl.orderBy, \'since\']" ng-click="$ctrl.onUnmarkDevice(device)" ng-class="{warning: device.hasChangedStatus}"><td><a ng-click="$ctrl.onSelectDevice(device); $event.stopPropagation();"><strong ng-if="device.hasChangedStatus">{{device[description_attr]}}</strong> <span ng-if="!device.hasChangedStatus">{{device[description_attr]}}</span></a></td><td translate-namespace="admin.parking.status"><span ng-switch="device.status"><span ng-switch-when="free" class="label label-success" translate>.Free</span> <span ng-switch-when="occupied" class="label label-danger" translate>.Occupied</span> <span ng-switch-when="offline" class="label label-default" translate>.Offline</span></span></td><td class="text-right"><span ng-if="device.since" title="{{device.since | date: \'dd/MM/yy, HH:mm\'}}">{{device.since | momentAgo}}</span></td><td class="text-right"><span ng-if="device.created_at" title="{{device.created_at | date: \'dd/MM/yy, HH:mm\'}}">{{device.created_at | momentAgo}}</span></td></tr></tbody></table>',
        controller: ParkingStatusTableController,
        controllerAs: '$ctrl',
        bindings: {
            onSelectedDeviceChange: '&'
        }
    });

    function ParkingStatusTableController($interval, $q, $state, appConfig, iotService, localStorageService) {
        'ngInject';

        var $ctrl = this;

        ////////////////

        /**
         * 
         */
        $ctrl.$onInit = function () {
            var lastUpdate = localStorageService.get('parkingStatusUpdate');

            $ctrl.devices = [];
            if (moment(lastUpdate).diff(moment(), 'minutes') < 60) {
                $ctrl.devices = localStorageService.get('parkingStatus');
            }

            $ctrl.orderBy = '-presence';
            $ctrl.updater = update();
            $ctrl.updater = $interval(update, 60000, 1000);
        };

        /**
         * 
         */
        $ctrl.$onDestroy = function () {
            $interval.cancel($ctrl.updater);
            localStorageService.set('parkingStatus', $ctrl.devices);
            localStorageService.set('parkingStatusUpdate', moment().toISOString());
        };

        /**
         * 
         * @param {*} column 
         */
        $ctrl.toggleOrderBy = function (column) {
            var operator = '+';

            if ($ctrl.orderBy.substring(1) === column) {
                operator = $ctrl.orderBy.substring(0, 1) === '+' ? '-' : '+';
            }

            $ctrl.orderBy = '' + operator + column;
        };

        /**
         * 
         * @param {*} device 
         */
        $ctrl.onUnmarkDevice = function (device) {
            device.hasChangedStatus = false;
        };

        /**
         * 
         * @param {*} device 
         */
        $ctrl.onSelectDevice = function (device) {
            $ctrl.onSelectedDeviceChange({ device: device });
        };

        /**
         * 
         */
        function update() {

            $q.all({
                parkingStatuses: iotService.getParkingDevicesWithStatus()
            }).then(function (r) {
                var oldDevices = _.keyBy($ctrl.devices, 'id');
                var newDevices = _.filter(r.parkingStatuses, function (o) {
                    return o.latitude || o.longidute;
                });

                angular.forEach(newDevices, function (newDevice) {
                    var oldStatus = _.get(oldDevices, newDevice.id + '.status', undefined);
                    var oldHasChangedStatus = _.get(oldDevices, newDevice.id + '.hasChangedStatus', undefined);

                    newDevice.hasChangedStatus = newDevice.status == 'occupied' && (oldHasChangedStatus || oldStatus !== newDevice.status);
                });

                $ctrl.devices = newDevices;
            }).catch(function (error) {
                if (error.status === 401) {
                    $state.go('login');
                }

                console.error('Oops, something went wrong!', error);
            });
        }
    }
})();